import styled from 'styled-components'
import { Typography, Subtitle as DefaultSubtitle } from '~components'

export const List = styled.ul`
  list-style: none;
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`

export const Item = styled.li`
  display: flex;
  padding: ${({ theme }) => theme.spacing.km2} ${({ theme }) => theme.spacing.km3};

  p {
    margin-left: ${({ theme }) => theme.spacing.km4};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    flex: 1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    padding: ${({ theme }) => theme.spacing.km2} ${({ theme }) => theme.spacing.km5}
      ${({ theme }) => theme.spacing.km2} ${({ theme }) => theme.spacing.km1};
    margin-bottom: ${({ theme }) => theme.spacing.km2};
  }
`

export const Text = styled(Typography).attrs({ as: 'p' })`
  color: ${({ theme }) => theme.neutral.text.default};
`

export const Subtitle = styled(DefaultSubtitle)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`
